import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly sidebarStateSubject = new BehaviorSubject<boolean>(false);
  public sidebarState$ = this.sidebarStateSubject.asObservable();

  constructor() {
    // Inicializa o estado baseado no tamanho da tela
    this.initializeSidebarState();

    // Escuta mudanças no tamanho da tela
    window.addEventListener('resize', () => {
      this.handleResize();
    });
  }

  private initializeSidebarState(): void {
    const isMobile = window.innerWidth <= 767.98;
    const isCollapsed = isMobile;
    this.sidebarStateSubject.next(isCollapsed);
    this.applySidebarState(isCollapsed);
  }

  private handleResize(): void {
    const isMobile = window.innerWidth <= 767.98;
    const currentState = this.sidebarStateSubject.value;

    if (isMobile && !currentState) {
      // Em mobile, força o colapso se não estiver colapsado
      this.toggleSidebar();
    }
  }

  toggleSidebar(): void {
    const currentState = this.sidebarStateSubject.value;
    const newState = !currentState;

    this.sidebarStateSubject.next(newState);
    this.applySidebarState(newState);
  }

  private applySidebarState(isCollapsed: boolean): void {
    const sidebar = document.querySelector('#sidebar');
    if (sidebar) {
      if (isCollapsed) {
        sidebar.classList.add('collapsed');
      } else {
        sidebar.classList.remove('collapsed');
      }
    }
  }

  getSidebarState(): boolean {
    return this.sidebarStateSubject.value;
  }
}
